import { render, staticRenderFns } from "./cl-header.vue?vue&type=template&id=7938f38f&scoped=true&"
import script from "./cl-header.vue?vue&type=script&lang=ts&"
export * from "./cl-header.vue?vue&type=script&lang=ts&"
import style0 from "./cl-header.vue?vue&type=style&index=0&id=7938f38f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7938f38f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
